import { createTheme, ThemeProvider } from "@mui/material/styles";

import RTL from "./RTL";

const theme = createTheme({
  direction: "rtl",

  spacing: 8,

  typography: {
    fontFamily: "Kalameh, sans-serif",
  },

  palette: {
    mode: "light",
    primary: {
      main: "#2349EC",
      contrastText: "#fff",
    },
    secondary: {
      main: "#357FFE",
      contrastText: "#fff",
    },
    success: {
      main: "#25BDA2",
      contrastText: "#fff",
    },
    error: {
      main: "#E45656",
      contrastText: "#fff",
    },
    text: {
      primary: "#1F1F1F",
      secondary: "#686868",
    },
  },

  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "10px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: "#fff",
          boxShadow: "none",
          borderRadius: "15px",
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          "& button": {
            color: "#fff",
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          padding: "12px",

          "& input": {
            padding: "0px",
          },
          "&::after": {
            display: "none",
          },
          "&::before": {
            display: "none",
          },
        },
      },
    },
  },
});

export default function MUITheme({ children }: any) {
  return (
    <RTL>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </RTL>
  );
}
